import { always, complement, length, pipe, take, when } from 'ramda';
import sumBy from 'lodash/fp/sumBy';
import orderBy from 'lodash/fp/orderBy';
import map from 'lodash/fp/map';

export const getTotal = slice => pipe(slice, sumBy('amountWithFees'));
export const sumQuantity = sumBy('quantity');
const emptyChartData = [{
  name: 'No data available',
  empty: true,
  value: 1,
  id: 'no data',
}];
export const getChartData = slice => pipe(
  slice,
  orderBy('amount', ['desc']),
  take(5),
  map(({ id, name, amountWithFees }) => ({
    id,
    name,
    value: amountWithFees,
  })),
  when(
    complement(length),
    always(emptyChartData),
  ),
);

export const getMostSold = pipe(
  orderBy('quantity', ['desc']),
  take(5),
  map(({ id, name, quantity }) => ({
    id,
    name,
    value: quantity,
  })),
);
